import { render } from "./IconLeaf.vue?vue&type=template&id=eda6ac5a"
import script from "./IconLeaf.vue?vue&type=script&lang=js"
export * from "./IconLeaf.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__